export default function getDPR(element: Element): number {
  if (typeof window === 'undefined') {
    return 1
  }
  const win = element.ownerDocument.defaultView || window
  return win.devicePixelRatio || 1
}
